export const SHOW_SUCCESS_ALERT = 'SHOW_SUCCESS_ALERT';
export const HIDE_SUCCESS_ALERT = 'HIDE_SUCCESS_ALERT';
export const SHOW_ERROR_ALERT = 'SHOW_ERROR_ALERT';
export const HIDE_ERROR_ALERT = 'HIDE_ERROR_ALERT';
export const GET_CARD_TRANSACTIONS = 'GET_CARD_TRANSACTIONS';
export const SET_CARD_TRANSACTIONS = 'SET_CARD_TRANSACTIONS';
